import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from "react-redux";
import Editor from "./editor";
import {clearHotspot, setSelectedHotspotId} from "../actions";
import GenericImageMap from 'virtual_congress/components/generic_image_map'
import {HotspotPreview} from "../components/hotspot_preview";
import {ImageMapProvider} from "../components/image_map_provider";

const cleanHotspotEffect = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearHotspot());
  }, [])
}

export default function EventBoothManager() {
  cleanHotspotEffect()

  const dispatch = useDispatch()

  const imageMap = useSelector((state) => state.imageMap)
  const selectedHotspotId = useSelector((state) => state.selectedHotspotId);
  const hotspotUpdateData = useSelector((state) => state.hotspotUpdateData);
  const hasUnsavedChanges = selectedHotspotId && !_.isEmpty(hotspotUpdateData);
  const unmodifiedHotspotData = useSelector(state => state.imageHotspots.find((ih) => ih.id === selectedHotspotId))
  const updateHotspotData = hotspotUpdateData ? hotspotUpdateData[selectedHotspotId] : null
  const selectedHotspot = updateHotspotData || unmodifiedHotspotData

  const [hotspotId, setHotspotId] = useState(null)
  const [currentSlideshowImageId, setCurrentSlideshowImageId] = useState(null)

  const hotspot = useSelector(state => state.imageHotspots.find(h => h.id === hotspotId))
  const selectedSlideshowImage = useSelector(state => state.imageHotspotSlideshowImages.find(si => si.id === currentSlideshowImageId))

  const onHotspotClick = (hotspot, currentSlideshowImage) => {
    setHotspotId(hotspot?.id)
    setCurrentSlideshowImageId(currentSlideshowImage?.id)

    if (hasUnsavedChanges) {
      alert("You have to save or discard the changes for the selected hotspot first.");
    } else if (hotspot) {
      if(hotspot?.id != hotspotId) {
        dispatch(setSelectedHotspotId(hotspot?.id))
      } else {
        //console.warn("already seleced")
      }
      
    }
  }

  const onModalClose = () => {
    if (hasUnsavedChanges) {
      alert("You have to save or discard the changes for the selected hotspot first.");
    } else if (hotspot) {
      setHotspotId(null)
      setCurrentSlideshowImageId(null)
      dispatch(clearHotspot())
    }
  }

  return <ImageMapProvider imageMap={imageMap}>
    <div className="row no-gutters">
      <div className="col-12 col-md-8">
        <div className="row">
          <div className="col-12">
            <div className="ml-2 ml-md-4 mr-2 my-4 shadow" style={{position: "relative"}}>
              <div className="preview-container">
                <HotspotPreview
                  hotspot={hotspot}
                  key={selectedSlideshowImage?.id || hotspot?.id}
                  id={selectedSlideshowImage?.id || hotspot?.id}
                  kind={selectedHotspot?.kind || selectedSlideshowImage?.kind || hotspot?.kind}
                  data={selectedHotspot?.data || selectedSlideshowImage?.data || hotspot?.data}
                  imageMap={imageMap}
                  onModalClose={onModalClose}/>
                <GenericImageMap
                  dotted={true}
                  isEventBooth={true}
                  onHotspotClick={onHotspotClick}
                  showHiddenHotspots={true}
                  imageMap={imageMap}/>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="ml-2 ml-md-4 mr-2 my-4 p-3 shadow">
              Here you can view your booth from a users perspective:{" "}
              <a href={`/exhibition/preview#/image_map/${imageMap.id}/`} target={"_BLANK"}>Your Booth</a>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-4">
        <Editor selectedHotspot={selectedHotspot}/>
      </div>
    </div>
  </ImageMapProvider>
}
